import React, { Component } from "react";
import { Form } from "react-bootstrap";
// import Pagination from "@mui/material/Pagination";
import { Toaster, toast } from "react-hot-toast";
import { connect } from "react-redux";
import ManageUserService from "../../../api/ManageUserService";
import AdminEmployeeGrid from "./AdminEmployeeGrid";
import { ComponetArray } from "../ComponentArray";
import CreateOwner from "./CreateOwner";
import Pagination from "@mui/material/Pagination";
import * as XLSX from "xlsx";
import NavigationChange from "../../../components/NavigationChange";

class AdminEmployeeContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userList: [],
      userCount: 0,
      totalPageNo: null,
      openModal: false,
      changeStateforEdit: false,
      pageNo: 0,
      search: "",
      gender: "",
      anchorEl: null,
      editValue: {},
      reportData: [],
      sortBy: "lastSubscribedUser",
      filterBy: '',
    };
  }

  componentDidMount = () => {
    this.getAllEmployee();
  };

  getAllEmployee = () => {
    let obj = {
      pageNo: 0,
      search: "",
      sortBy: this.state.sortBy,
      filterBy: this.state.filterBy,
    };

    this.getAllAdminData(obj);
    // ManageUserService.getAllUserForAdmin(obj).then((response) => {
    //   console.log("response", response.data.data);

    //   if (response.data.data) {
    //     this.setState({
    //       userList: response.data.data.userList,
    //       totalPageNo: response.data.data.totalPage,
    //       userCount: response.data.data.TotalCount,
    //     });
    //   }
    // });
  };

  render() {
    console.log("pageNo:::::", this.state.pageNo);
    return (
      <>
        <div className="Heading">
          <NavigationChange
            Topics={"Employer"}
            numberofRecord={this.state.userCount}
            specficwidth={"134"}
            back={false}
          />
        </div>
        <div className="container-of-createButton" id="titleWithDropdowns">
          <div className="d-flex flex-row">
            <div className="search-contain me-3">
              <Form.Label style={{ fontSize: "17px" }}>Search</Form.Label>

              <div className="search ">
                <span className="fa fa-search" onClick={this.search}></span>
                <input
                  type="text"
                  placeholder="Employer Name or Email"
                  name="search"
                  value={this.state.search}
                  onKeyPress={this.handleKeyPress}
                  onChange={this.searchvalue}
                />
              </div>
            </div>
            <div className="resource-conatiner me-3">
              <Form.Label style={{ fontSize: "17px" }}>Sort By</Form.Label>
              <select
                value={this.state.sortBy}
                onChange={(event) => this.sortByMethod(event.target.value)}
                style={{
                  backgroundColor: "#F3F4F1",
                  color: "#000",
                  borderColor: "#F3F4F1",
                  width: "100%",
                  height: "36px",
                  borderRadius: "5px",
                }}
              >
                <option value="lastSubscribedUser">
                  Latest Subscribed User
                </option>
                <option value="lastCreated">New ➝ Old Employer</option>
              </select>
            </div>

            <div className="resource-conatiner">
              <Form.Label style={{ fontSize: "17px" }}>Filter By</Form.Label>
              <select
                value={this.state.filterBy}
                onChange={(event) => this.filterByMethod(event.target.value)}
                style={{
                  backgroundColor: "#F3F4F1",
                  color: "#000",
                  borderColor: "#F3F4F1",
                  width: "100%",
                  height: "36px",
                  borderRadius: "5px",
                }}
              >
                <option value="">
                  All platform
                </option>
                <option value="ios">iOS</option>
                <option value="android">Android</option>
                <option value="null">UnSubscribed Employeer</option>
              </select>
            </div>
          </div>

          <div className="create-button">
            <div className="button-end">
              <button
                className="btn btn-success formshop-btn"
                onClick={this.OpenReport}
                style={{
                  marginRight: "20px",
                }}
              >
               Employer Report
              </button>

              <button
                className="btn btn-success formshop-btn"
                onClick={this.OpenCreateTask}
              >
                Add Employer
              </button>
            </div>
          </div>
        </div>
        <AdminEmployeeGrid
          userList={this.state.userList}
          ActiveEdit={(a) => this.activeEdit(a)}
          componentList={ComponetArray}
          onLoad={this.getAllEmployee}
        />

        <div className="mt-3" style={{ width: "99%", margin: "0 auto" }}>
          <div className="d-flex justify-content-center">
            <Pagination
              count={this.state.totalPageNo}
              onChange={(event, value) => this.handlePageChange(value)}
              page={this.state.pageNo + 1}
            />
          </div>
        </div>

        {this.state.openModal && (
          <CreateOwner
            handleClose={this.closeHandleclose}
            show={this.state.openModal}
            onLoad={this.getAllEmployee}
            option={!this.state.changeStateforEdit ? "new" : "edit"}
            editValue={this.state.editValue}
            renderToast={(a) => this.renderToast(a)}
            errorToast={(a) => this.errorToast(a)}
            createEmployer={true}
          />
        )}
        <Toaster />
      </>
    );
  }

  OpenReport = () => {
    ManageUserService.getReport({}).then((response) => {
      console.log("response", response.data.data);

      this.setState(
        {
          reportData: response.data.data,
        },
        () => {
          let rawData = response.data.data;

          const formattedData = rawData.map(({ 
            firstName, lastName, mailID, phone_no, lastLogin, platform, 
            createdDate, updatedDate, employees, purchaseDate, id 
        }) => ({
            "First Name": firstName,
            "Last Name": lastName,
            "Mail ID": mailID,
            "Phone No": phone_no || "N/A",
            "Last Login": lastLogin || "N/A",
            "Platform": platform === "ios" ? "iOS" : platform === "android" ? "Android" : "No active subscription",
            "Joined Date": createdDate ? new Date(createdDate).toLocaleString() : "N/A",
            "Last Updated": updatedDate ? new Date(updatedDate).toLocaleString() : "N/A",
            "Employees": employees,
            "Purchased Date": purchaseDate ? new Date(purchaseDate).toLocaleString() : "N/A",
            // "ID": id
        }));
        
        const ws = XLSX.utils.json_to_sheet(formattedData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Employers");
        XLSX.writeFile(wb, "Employerslist.xlsx");
        }
      );
    });
  };

  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      this.search();
    }
  };

  handleFilterClick = (event) => {
    this.setState({
      anchorEl: event.target,
    });
  };

  handleFilterClose2 = () => {
    this.setState({
      anchorEl: null,
    });
  };

  searchvalue = (event) => {
    this.setState(
      {
        [event.target.name]: event.target.value,
      },
      () => {
        if (event.target.value.length === 0) {
          this.search();
        }
      }
    );
  };

  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      this.search();
    }
  };

  search = () => {
    this.setState(
      {
        pageNo: 0,
      },
      () => {
        let obj = {
          pageNo: 0,
          search: this.state.search,
          sortBy: this.state.sortBy,
          filterBy: this.state.filterBy,
        };
        this.getAllAdminData(obj);
      }
    );
    // ManageUserService.getAllUserForAdmin(obj).then((response) => {
    //   console.log("response", response);
    //   if (response.data && response.data.data) {
    //     this.setState({
    //       userList: response.data.data.userList,
    //       totalPageNo: response.data.data.totalPage,
    //       userCount: response.data.data.TotalCount,
    //     });
    //   }
    // });
  };

  activeEdit = (a) => {
    console.log("a in air", a);
    this.setState({
      changeStateforEdit: true,
      editValue: a,
      openModal: true,
    });
  };

  OpenCreateTask = () => {
    this.setState({
      openModal: true,
      changeStateforEdit: false,
    });
  };

  closeHandleclose = () => {
    this.setState({
      openModal: false,
    });
  };

  handlePageChange = (i) => {
    let page = null;
    if (i === 1) {
      page = 0;
    } else {
      page = i - 1;
    }
    this.setState({ pageNo: page }, () => {
      let obj = {
        pageNo: this.state.pageNo,
        search: this.state.search,
        sortBy: this.state.sortBy,
        filterBy: this.state.filterBy,
      };
      this.getAllAdminData(obj);
    });
  };

  getAllAdminData = (obj) => {
    ManageUserService.getAllUserForAdmin(obj).then((response) => {
      console.log("response", response);
      if (response.data && response.data.data) {
        this.setState({
          userList: response.data.data.userList,
          totalPageNo: response.data.data.totalPage,
          userCount: response.data.data.TotalCount,
        });
      }
    });
  };

  sortByMethod = (sortBy) => {
    this.setState({ sortBy: sortBy, pageNo: 0 }, () => {
      let obj = {
        pageNo: this.state.pageNo,
        search: this.state.search,
        sortBy: this.state.sortBy,
        filterBy: this.state.filterBy,
      };
      this.getAllAdminData(obj);
    });
  };

  filterByMethod = (filterBy) => {
    console.log("filterBy::", filterBy);
    this.setState({ filterBy: filterBy, pageNo: 0 }, () => {
      let obj = {
        pageNo: this.state.pageNo,
        search: this.state.search,
        sortBy: this.state.sortBy,
        filterBy: this.state.filterBy,
      };
      this.getAllAdminData(obj);
    });
  };

  renderToast = (a) => {
    toast.success(`Owner ${a} Successfully`);
  };

  errorToast = (status) => {
    toast.error(`${status}`);
  };
}

const mapStateToProps = function (state) {
  return {};
};

const mapDispatchToProps = function (dispatch) {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminEmployeeContainer);
